import { ComponentProps } from 'react';

import { WidthOptions } from '@/types';
import clsx from 'clsx';

export interface BlockBase {
  id?: string;

  // these should be destructured from the props so they're not passed to the dom
  params: {
    domain: string;
    venue?: string;
    /** venuesPage isn't really a dynamic param but we simulate it in middleware so it doesn't interfere with the catchall route at brand level */
    venuesPage?: string | null;
  };
  margin?: Margin;
}

export type MarginOptions = 'none' | 'less' | 'default' | 'more';
export type Margin = { margin: { top: MarginOptions; bottom: MarginOptions } };

export const columnsClassName = 'flex flex-col gap-8 @container group w-full';
export const childClassNames =
  '[&>div:not(.accent-section)]:p-0 [&>form]:p-0 [&>section]:not([data-component="card"]):p-0 [&>ul]:p-0';

export const getMarginClassNames = (margin: Margin | undefined) =>
  clsx({
    '-mt-8 sm:-mt-20': margin?.margin?.top === 'none',
    '-mb-8 sm:-mb-20': margin?.margin?.bottom === 'none',

    '-mt-4 sm:-mt-10': margin?.margin?.top === 'less',
    '-mb-4 sm:-mb-10': margin?.margin?.bottom === 'less',

    'mt-4 sm:mt-10': margin?.margin?.top === 'more',
    'mb-4 sm:mb-10': margin?.margin?.bottom === 'more',
  });

export const getBlockWidthClassNames = (
  blockWidth: WidthOptions | undefined,
  defaultWidth: WidthOptions = 'standard',
) =>
  clsx({
    'max-w-none!': blockWidth === 'full' || (defaultWidth === 'full' && !blockWidth),
    'max-w-[theme(screens.3xl)]!': blockWidth === 'desktop' || (defaultWidth === 'desktop' && !blockWidth),
    'max-w-(--breakpoint-2xl)!': blockWidth === 'wide' || (defaultWidth === 'wide' && !blockWidth),
    'max-w-(--breakpoint-xl)!': blockWidth === 'standard' || (defaultWidth === 'standard' && !blockWidth),
    'max-w-(--breakpoint-lg)!': blockWidth === 'narrow' || (defaultWidth === 'narrow' && !blockWidth),
    'max-w-(--breakpoint-md)!': blockWidth === 'prose' || (defaultWidth === 'prose' && !blockWidth),
  });

export function Wrapper({ children, className, id }: ComponentProps<'div'>) {
  return (
    <div id={id} className={clsx('z-10 flex w-full max-w-(--breakpoint-2xl) justify-center px-4 sm:px-8', className)}>
      {children}
    </div>
  );
}
